export enum StaffSelectionMode {
  PIN = "PIN",
  NAME = "NAME",
  OFF = "OFF",
}
